import styled from 'styled-components'
import ReactLoading from 'react-loading';
import Lottie from 'react-lottie';

export const hexToRgb = (hex) => {
    var c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('');
        if (c.length === 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = '0x' + c.join('');
        return [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',');
    }
    return `255,255,255`
}

export const Touch = styled.div.attrs({
})`         
    cursor: pointer;
    &:hover{
        box-shadow: 0px 1px 3px ${props => props.theme.palette.colors.shadow};
    }
`;

export const TouchScale = styled.div.attrs({
})`         
    cursor: pointer;
    transition: all .3s ease;
    &:hover{
        transform: scale(1.2);
    }
`;

export const Load = styled(ReactLoading).attrs(p => ({
    type: 'spin',
    color: p?.white ? p.theme.palette.colors.white : p.theme.palette.colors.black,
    height: 20,
    width: 20
}))`          
`;

export const Animation = styled(Lottie).attrs(props => ({
    options: {
        loop: true,
        autoplay: true,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        },
        animationData: props.animationData
    },
    width: props.width ? props.width : 320
}))`        
    max-width: 100%;
`;

export const EmptyMessage = styled.div.attrs({
})`         
    padding: 32px; 
    text-align: center;
    font-size: 14px;
    color: ${props => props.theme.palette.colors.black};
`;

export const LoadCenter = styled.div.attrs({
})`         
    width: 20px;
    margin: 32px auto; 
    display: flex;
    justify-content: center;
`;

export const DecoratedScroll = styled.div.attrs({
})`

    overflow: auto; 

    ::-webkit-scrollbar-thumb {
        background-color: ${props => props.theme.palette.secondary.main};
        outline: 0 solid ${props => props.theme.palette.secondary.main};
    }

    ::-webkit-scrollbar {
        width: 1px;
        height: .2rem;
    }

    ::-webkit-scrollbar-track {  
    }
`;


export const Icon = styled.img.attrs((props) => ({
    src: `/icons/${props.icon}.svg`,
}))` 
    max-width: 100%;
    width: ${props => props.width ? props.width : ''};
    height: ${p => p.height ? p.height : ''};
    margin: ${props => props.nomargin ? `0` : `0 2px`} ;
    z-index: 1;

    ${props => props.pointer ? `cursor: pointer;` : ``};
`;


export const Title = styled.div.attrs({
})`           

    font-weight: Gilroy;
    font-size: ${props => props.small ? `20px` : `32px`};
    font-weight: 700;
    text-align: ${props => props.centred ? `center` : `left`};
    margin-bottom: ${props => props.nomargin ? `0` : `16px`};
    text-transform: ${props => props.upper ? `uppercase` : `none`};
    color: ${props => props?.primary ? props.theme.palette.primary.main : props.theme.palette.colors.text};
`;

export const ButtonContainer = styled.div.attrs({
})`
    display: flex;
    ${p => p.column ? `
        flex-direction: column;
        ${p.start ? `align-items: flex-start;` : ``}
        ${p.center ? `align-items: center;` : ``}
        ${p.end ? `align-items: flex-end;` : ``}
    ` : ``};    

    justify-content: space-between;
    ${p => p.start ? `justify-content: flex-start;` : ``}
    ${p => p.center ? `justify-content: center;` : ``}
    ${p => p.end ? `justify-content: flex-end;` : ``}

    width: 100%;
    ${p => p.space ? `gap: 24px` : ``}
`;

export const FormTitle = styled.div.attrs({
})`
    font-size: 14px;
    font-weight: 700;
    letter-spacing: -0.005em;
    text-align: left;
    text-transform: uppercase;
    color: ${props => props.theme.palette.colors.subdued};
`;

export const FormText = styled.div.attrs({
})`
    font-size: 18px;
    font-weight: 300;
    text-align: ${p => p.center ? `center` : 'left'};
    color: ${props => props.theme.palette.colors.muted};
    margin-bottom: 8px;
    ${p => p.success ? `
            text-align: ;
        ` : ''};
`;

export const FormSpacer = styled.div.attrs({
})`
    margin-top: 24px;
    ${props => props.large ? `margin-top: 40px;` : ``}
    ${props => props.extraLarge ? `margin-top: 80px;` : ``};
    ${props => props.border ? `
        border-top: 0.5px solid ${props.theme.palette.colors.border};
        margin-bottom: 32px;
`: ``};
`;

export const Overlay = styled.div.attrs({
})`
    position: fixed;
    top: ${props => props.$belowHeader ? '80px' : '0'};
    left: 0;
    right: 0;
    bottom: 0;
    background:
        radial-gradient(circle at top, ${props => props.theme.palette.colors.shellGlow} 0%, ${props => props.theme.palette.colors.backgroundTransparent} 38%),
        ${props => props.theme.palette.colors.backdrop};
    backdrop-filter: blur(18px);
    -webkit-backdrop-filter: blur(18px);
    z-index: 1000;
    cursor: auto;
`;

export const ModalContainer = styled.div.attrs({
})`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 28px;
    width: 100%;
    box-sizing: border-box;

    ${props => props.$viewportSpacing ? `
        align-items: start;
        height: 100%;
        height: calc(100vh - 80px);
        left: 0;
        padding: 32px 28px;
        top: 0;
        transform: none;
    ` : ``}

    @media (max-width: 1000px) {
        align-items: ${props => props.$belowHeader ? 'flex-start' : props.$viewportSpacing ? 'center' : 'flex-start'};
        padding: 24px 16px;
    }

    @media (max-width: 480px) {
        padding: ${props => props.$viewportSpacing ? '16px 12px' : '24px 16px'};
    }

    ${props => props.$belowHeader ? `
        position: absolute;
        inset: 0;
        height: 100%;
        transform: none;
        align-items: flex-start;
    ` : ''}
`;

export const ModalContent = styled.div.attrs({
})`
    width: 100%;
    overflow-y: auto; 
    max-height: ${props => props.$viewportSpacing ? 'calc(100vh - 64px)' : '90vh'};
    ${props => props.$viewportSpacing ? 'max-height: calc(100dvh - 64px);' : ''}
    overscroll-behavior: contain;
    scrollbar-width: thin;
    scrollbar-color: ${props => props.theme.palette.blue.main} ${props => props.theme.palette.colors.light};
    box-sizing: border-box;
    animation: modalReveal 0.32s cubic-bezier(0.2, 0.8, 0.2, 1);
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: ${props => props.$width || '1080px'};
    background:
        linear-gradient(180deg, ${props => props.theme.palette.colors.backgroundSoft} 0%, ${props => props.theme.palette.colors.backgroundStrong} 100%);
    border: 1px solid ${props => props.theme.palette.colors.borderStrong};
    box-shadow:
        0 28px 80px ${props => props.theme.palette.colors.shadowLift},
        inset 0 1px 0 ${props => props.theme.palette.colors.light};
    padding: 32px;
    border-radius: 28px;
    ::-webkit-scrollbar {
        width: 6px;
        background: transparent;
    }

    ::-webkit-scrollbar-track {
        background: ${props => props.theme.palette.colors.light};
        border-radius: 999px;
    }

    ::-webkit-scrollbar-thumb {
        background: ${props => props.theme.palette.blue.main};
        border-radius: 999px;
    }

    @keyframes modalReveal {
        from {
            opacity: 0;
            transform: translateY(24px) scale(0.98);
        }
        to {
            opacity: 1;
            transform: translateY(0) scale(1);
        }
    }

    @media (max-width: 1000px) {
        max-height: calc(100vh - 48px);
        ${props => props.$viewportSpacing ? 'max-height: calc(100dvh - 48px);' : ''}
        width: min(100%, 960px);
        padding: 24px;
        max-width: 100%;
    }

    @media (max-width: 480px) {
        max-height: calc(100vh - 32px);
        ${props => props.$viewportSpacing ? 'max-height: calc(100dvh - 32px);' : ''}
        padding: 18px;
        gap: 18px;
        border-radius: 22px;
    }

    ${props => props.$belowHeader ? `
        max-height: calc(100vh - 144px);
        max-height: calc(100dvh - 144px);

        @media (max-width: 1000px) {
            max-height: calc(100vh - 128px);
            max-height: calc(100dvh - 128px);
        }

        @media (max-width: 480px) {
            max-height: calc(100vh - 112px);
            max-height: calc(100dvh - 112px);
        }
    ` : ''}
`;


export const FullLoad = styled.div.attrs({
    children: <>
        <Load white />
    </>
})`
    position: fixed;
    inset: 0 0 0 0;
    z-index: 999;
    background: ${({ theme }) => theme.palette.colors.shadow};
    display: flex;
    justify-content: center;
    align-items: center;
`;


export const SafeImage = styled.img.attrs({
    onError: e => e.target.style.display = 'none'
})``
export const UnauthenticatedContainer = styled.div.attrs({
})` 
    background: ${props => props.theme.palette.colors.surfaceElevatedSoft};
    width: 100%;
    max-width: ${p => p.full ? `100%` : `520px`};
    height: 100%;
    padding: 40px;
    display: flex;
    margin: auto;
    flex-direction: column;
    justify-content: center;
    gap: 24px;
    border-radius: ${p => p.noradius ? `0` : `28px`};
    border: 1px solid ${p => p.theme.palette.colors.borderSoft};
    box-shadow:
        0 26px 72px ${p => p.theme.palette.colors.shadowStrong},
        inset 0 1px 0 ${p => p.theme.palette.colors.borderSoft};
    backdrop-filter: blur(18px);
    @media(max-width: 767px){
        padding: 24px;
        border-radius: 24px;
    }
`;

export const Content = styled.div.attrs({
})`
   padding: 24px 0 24px 48px;
    @media (max-width: 991px) {
    padding: 24px 0 24px 16px;
  }
`;

export const FormContent = styled.div.attrs({})`
    border-radius: 8px;
`;

export const StatusContent = styled.div.attrs({
})`
    border-radius: 4px;
    padding: 7px 16px;
    font-family: Lato;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    text-align: center;
    color: ${props => props.theme.palette.colors.white};
    background: ${props => props.theme.palette.status?.[props.color]};
    text-transform: uppercase;
`;

export const ContentIcon = styled.div.attrs({})`
    display: flex;
    justify-content: space-between;
`;



export const InputRequired = styled.b.attrs({
})`
    font-size: 22px;
    color: ${p => p.theme.palette.colors.grey};
`;
